import React, { useEffect, useState } from "react";
import {
  CloseBtn,
  HeaderContentWrapper,
  MenuIcon,
  MenuItemWrapper,
  MenuWrapper,
  StyledHeaderBrand,
  StyledHeaderWrapper,
  StyledNav,
  StyledNavItem,
} from "./styled";
import { ReactComponent as SausageLogo } from "assets/logo/logo-sausage.svg";
import ConnectButton from "./ConnectButton";
// import { handleOpen, navbarSelector } from "state/navbarSlice";
// import { useSelector, useDispatch } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
// import { useCheckNetwork } from "hooks/CheckNetwork";

const menus = [
  { name: "Mint Sausages", to: "/mint" },
  { name: "Community", to: "/community" },
  { name: "Roadmap", to: "/roadmap" },
  { name: "Shop", to: "/shop" },
];

const Header = () => {
  // const { isNavOpen } = useSelector(navbarSelector);
  // const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  // const { connected, correctNetwork } = useCheckNetwork();
  const FramerMenuWrapper = motion(MenuWrapper);
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflowY = "auto";
    }
  }, [open]);

  return (
    <>
      <StyledHeaderWrapper isOpen={false}>
        <HeaderContentWrapper>
          <StyledHeaderBrand>
            <Link to="/">
              <SausageLogo width={125} height={40} className="doge-logo" />
            </Link>
          </StyledHeaderBrand>
          <StyledNav>
            {menus.map((menu) => (
              <StyledNavItem as={Link} to={menu.to} key={menu.name}>
                {menu.name}
              </StyledNavItem>
            ))}
          </StyledNav>
          <ConnectButton />
          {open ? (
            <CloseBtn onClick={() => setOpen(!open)} />
          ) : (
            <MenuIcon onClick={() => setOpen(!open)} />
          )}
        </HeaderContentWrapper>
      </StyledHeaderWrapper>
      <AnimatePresence
        initial={false}
        exitBeforeEnter={true}
        onExitComplete={() => null}
      >
        {open && (
          <FramerMenuWrapper
            initial={{ height: 0 }}
            animate={{ height: "100%" }}
            exit={{ height: 0 }}
            transition={{ type: "tween", duration: 0.2 }}
            isOpen={open}
          >
            <MenuItemWrapper>
              {menus.map((menu) => (
                <StyledNavItem as={Link} to={menu.to} key={menu.name}>
                  {menu.name}
                </StyledNavItem>
              ))}
            </MenuItemWrapper>
          </FramerMenuWrapper>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;

// menu.to === "/mint" ? (
//   connected &&
//   correctNetwork.length <= 0 && (
//     <StyledNavItem as={Link} to={menu.to} key={menu.name}>
//       {menu.name}
//     </StyledNavItem>
//   )
// )
